// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/60d7ed84f0558b7a5c11.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f03e4c7533fa7eff6272","143":"a92fd6e7cf798ec46c69","144":"a7d5c4c0ea01dad5af30"}[chunkId] + ".chunk.js";
};